import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraActivityFeed } from '@mono/ui-components/captains';
import { SpecraButton, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraRestrictedChip, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
// "24 Oct 2026" (d MMM YYYY), stable across runtimes.
const dayLabel = (d)=>d ? `${d.getUTCDate()} ${d.toLocaleDateString('en-US', {
        month: 'short',
        timeZone: 'UTC'
    })} ${d.getUTCFullYear()}` : 'Date unknown';
/** Touchpoints from pursuits and programs in one list (no actor: neither table records one). */ export function TouchpointsList({ touchpoints, visibleTotal, hasMore, loadingMore, onShowMore }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Touchpoints · from pursuits and programs",
                action: /*#__PURE__*/ _jsxs(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    "data-testid": Testids.registryPerson.touchpointsTotal,
                    children: [
                        visibleTotal,
                        " total"
                    ]
                })
            }),
            touchpoints.length === 0 ? /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: "No touchpoints you can see yet."
            }) : /*#__PURE__*/ _jsx(SpecraActivityFeed, {
                getItemTestId: ()=>Testids.registryPerson.touchpointRow,
                items: touchpoints.map((t)=>{
                    const href = registryHref(t.context);
                    return {
                        id: t.id,
                        title: t.masked ? 'Touchpoint · details restricted' : t.summary || 'Touchpoint',
                        timestamp: dayLabel(t.at),
                        description: t.masked ? /*#__PURE__*/ _jsx(SpecraRestrictedChip, {
                            label: "Restricted",
                            reason: "Touchpoint details on this pursuit are visible to its capture team."
                        }) : undefined,
                        actions: href ? /*#__PURE__*/ _jsx(SpecraLink, {
                            href: href,
                            renderLink: renderRouterLink,
                            children: t.context.name
                        }) : t.context.name
                    };
                })
            }),
            hasMore && /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "ghost",
                onClick: onShowMore,
                disabled: loadingMore,
                children: loadingMore ? 'Loading…' : 'Show more'
            })
        ]
    });
}
